export default class Grupo {
  _id = null;
  nome = "";
  descricao = "";
}
